module.exports = __webpack_public_path__ + "static/Olympo325-f624d58ced02dd6c43c99d4f1d3428c4.mp4";